import Image from 'Pages/Home/Components/Atoms/Image';
import { Col } from 'antd';
import Styles from './BannerCard.module.scss';
import { TBannerCard } from './definitions';

export default function BannerCard({ data }: TBannerCard) {
  return (
    <Col>
      <Image
        src={data.image}
        alt={data.name}
        className={Styles['banner-search-image']}
        onClick={() => window.open(data.redirectUrl, '_blank')}
        cdnWidth={2000}
      />
    </Col>
  );
}
